import { Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import Physician from "../../../Physician/Models/Physician";
import React, { Fragment } from "react";
import CCBlockEvaluationTernaryRequirement from "../../../Physician/Models/CCBlockEvaluationTernaryRequirement";


interface IProps{
    physician: Physician;
}

export default function CCBlockSummaryActivitiesMeeting(props: IProps) {
    const nbsp = '\u00A0';
    var isPatSafetyRequired = props.physician.currentCCEnrollment.currentCCBlock.isPatientSafetyRequired != CCBlockEvaluationTernaryRequirement.NotRequired;
    var isPipRequired = props.physician.currentCCEnrollment.currentCCBlock.isPipRequired;
    var isCMEComplete = props.physician.currentCCEnrollment.currentCCBlock.ccSummaryDashboard.isCMEComplete;
    var isPIPComplete = props.physician.currentCCEnrollment.currentCCBlock.ccSummaryDashboard.isPIPComplete;
    var isSACMEComplete = props.physician.currentCCEnrollment.currentCCBlock.ccSummaryDashboard.isSaCMEComplete;
    var isPatSafetyComplete = props.physician.currentCCEnrollment.currentCCBlock.ccSummaryDashboard.isPatSafetyComplete;
    var dueDate = new Date(props.physician.currentCCEnrollment.currentCCBlock.endDate);

    return (
        <Fragment>
            <div className="ccenrollment-summary-padding">
                <div className="ccenrollment-summary-border" style={{background: '#fff'}}>
                    <Row className="ccenrollment-summary-cert">
                        <Col>
                            <Row className="ccenrollment-certificate-header">
                                <Col>
                                    <div className="mb-0 card-title pp-font-size-small text-center"><b>Activities</b></div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                {isCMEComplete && (isPIPComplete || !isPipRequired) && isSACMEComplete && (isPatSafetyComplete || !isPatSafetyRequired) ? 
                <>
                    <Row>
                        <Col className="text-center">
                            <div className="text-success">
                                <div className="las la-check-circle la-3x">
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="pp-font-size-small text-center text-success">
                                <span>CC Activities Complete</span>
                            </div>
                        </Col>
                    </Row>
                </>
            :
                <>
                    <Row>
                        <Col className="text-center">
                            <div className="las la-clock la-3x"></div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="pp-font-size-small text-center">
                                <span>Due by {dueDate.getMonth()+1}/{dueDate.getDate()}/{dueDate.getFullYear()}</span>
                            </div>
                        </Col>
                    </Row>
                </>
}
                <Row>
                    <Col>
                        <div>
                            {nbsp}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col className="">
                        <div className="pp-font-size-smaller text-right"><b>CME: </b><span>{ isCMEComplete == true ? <b className="las la-check text-success pp-font-size-small" /> : <b className="las la-times text-danger pp-font-size-small" /> }</span></div>
                    </Col>
                    <Col md={1}>
                        <div />
                    </Col>
                    <Col className="">
                        <div className="pp-font-size-smaller text-right"><b>PIP: </b><span>{ isPipRequired == false ? <span>N/A</span> : (isPIPComplete == true ? <b className="las la-check text-success pp-font-size-small" /> : <b className="las la-times text-danger pp-font-size-small" />) }</span></div>
                    </Col>
                    <Col md={2}>
                        <div />
                    </Col>
                </Row>
                <Row>
                    <Col className="">
                        <div className="pp-font-size-smaller text-right"><b>SA-CME: </b><span>{ isSACMEComplete == true ? <b className="las la-check text-success pp-font-size-small" /> : <b className="las la-times text-danger pp-font-size-small" /> }</span></div>
                    </Col>
                    <Col md={1}>
                        <div />
                    </Col>
                    <Col className="">
                        <div className="pp-font-size-smaller text-right pr-md-0">
                            <OverlayTrigger
                                placement={"right"}
                                overlay={<Tooltip id="applicationDeadline" bsPrefix="pp-tooltip">
                                    PS = Patient Safety 
                                </Tooltip>}>
                                <i className="las la-info-circle ml-1 text-pp-secondary"></i>
                            </OverlayTrigger>
                            {nbsp}<b>PS: </b><span>{ isPatSafetyRequired == false ? <span>N/A</span> : (isPatSafetyComplete == true ? <b className="las la-check text-success pp-font-size-small" /> : <b className="las la-times text-danger pp-font-size-small" />) }</span>       
                        </div>    
                    </Col>    
                    <Col md={2}>
                        <div />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="pp-font-size-smaller">{nbsp}</div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="pp-font-size-smaller">{nbsp}</div>
                    </Col>
                </Row>
            </div>
        </div>
    </Fragment>
    );
}